import React from "react";
import PropTypes from "prop-types";
import { Container } from "@mui/material";
import { getCrmPaymentMethods } from "../../api";
import { useAnalyticsFetch } from "./hooks/useAnalyticsFetch";
import DoughnutChartCard from "./components/DoughnutChartCard";

const Payment = ({ filter, startDate, endDate }) => {
  const { data, loading } = useAnalyticsFetch(getCrmPaymentMethods, [filter, startDate, endDate]);

  return (
    <Container sx={{ paddingLeft: "0 !important", paddingRight: "0 !important" }}>
      <DoughnutChartCard
        title="Payment Methods"
        labels={data?.chart?.labels || []}
        series={data?.chart?.series || []}
        loading={loading}
        currency
      />
    </Container>
  );
};

Payment.propTypes = {
  filter: PropTypes.string.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default Payment;
